
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/premsa/ccma",
      function () {
        return require("private-next-pages/corporatiu/premsa/ccma/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/premsa/ccma"])
      });
    }
  